export default __webpack_public_path__ + "static/media/keto.797833e1.jpeg";